import React from "react";
import { Button, Result } from "antd";
import triggerAnalyticsClient from "../../services/analytics-services";

class ErrorBoundary extends React.Component {
  state: any;
  props: any;
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    triggerAnalyticsClient.emitEvent(
      "tn_error_catch",
      {
        module: "Tradenext-Web",
        activity: "Error Tracker",
      },
      {
        Error: JSON.stringify(error),
        ErrorInfo: errorInfo,
        Path: window.location.pathname,
      }
    );
    console.error("ErrorBoundary caught an error", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Result
          status="error"
          title="Something went wrong"
          subTitle="An unexpected error occurred. Please try again later."
          extra={
            <Button type="primary" onClick={this.handleReload}>
              Reload
            </Button>
          }
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
